import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { MapAgreement } from "@clinic/shared/data/splinters/MapAgreement.fragment";
import { MAP_AGREEMENT } from "@clinic/shared/data/splinters/MapAgreement.fragment";
import type { UsersMapAgreementStatusTypes } from "@clinic/shared/data/types/Maps.d";

const UsersMapAgreementCreate_ClinicShared_Mutation = gql`
  mutation UsersMapAgreementCreate_ClinicShared_Mutation($input: UsersMapAgreementCreateInput!) {
    usersMapAgreementCreate(input: $input) {
      usersMapAgreement {
        id
        status
        signedAt
        mapAgreement {
          ...MapAgreement
        }
      }
      errors {
        message
      }
    }
  }
  ${MAP_AGREEMENT}
`;

interface UsersMapAgreementCreateData {
  usersMapAgreementCreate: {
    usersMapAgreement: {
      status: UsersMapAgreementStatusTypes;
      signedAt: string;
      mapAgreement: MapAgreement;
    };
    errors: {
      message: string;
    };
  };
}

interface Variables {
  input: {
    mapAgreementId: string;
    status: UsersMapAgreementStatusTypes;
  };
}

const useMapAgreementCreateMutation = (
  options?: MutationHookOptions<UsersMapAgreementCreateData, Variables>
) => {
  return useMutation<UsersMapAgreementCreateData, Variables>(
    UsersMapAgreementCreate_ClinicShared_Mutation,
    options
  );
};

export type { UsersMapAgreementCreateData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useMapAgreementCreateMutation, UsersMapAgreementCreate_ClinicShared_Mutation };
